<template>
  <div id="app2" class="home">
    <el-row style="background: #fff;">
      <!-- 年报表 -->
      <el-col :span="4" v-show="flag" class="lefted">
        <!-- <span class="el-icon-d-arrow-left" v-show="flag" @click="
				   flag = !flag;
                    num = 24;
			"></span> -->
        <!-- 切换设备或者目录 -->
        <div class="switch">
          <img src="../../../../public/static/image/elTree/bg.png" alt="" :class="[{'img-active':activeIndex==1}]">
          <div :class="['switch-record' ,{'active':activeIndex==2}]" @click="recordFun">操作记录</div>

          <div :class="['switch-equipment' ,{'active':activeIndex==1}]" @click="activeIndex = 1">设备变量</div>
        </div>
        <!-- 设备变量 -->
        <div class="equipment" v-show="activeIndex == 1">
          <!-- 选择企业 -->
          <div class="screen-type">
            <div class="select-enterprise" @click="shouMenu = true">
              {{enterpriseName}}
            </div>
          </div>
          <div class="unitMenu" v-show="shouMenu" @mouseenter="shouMenu = true" @mouseleave="shouMenu = false">
            <div class="unitMenuTreeBody">
              <el-scrollbar style="height:calc(100% - 20px);width: 98%;">
                <el-tree :data="dataList" :expand-on-click-node="false" node-key="id" :props="defaultProps"
                  :highlight-current='true' :filter-node-method="filterNode" @node-click="enterpriseNodeClick">
                  <span class="custom-tree-node" slot-scope="{node}">
                    <img src="../../../../public/static/image/elTree/1.9.png" />
                    <span style="padding-left: 5px;">{{node.label}}</span>
                  </span>
                </el-tree>
              </el-scrollbar>
            </div>
          </div>
          <!-- 筛选类型 -->
          <div class="screen-type">
            <el-select v-model="screenTypevalue" placeholder="选择类型" :disabled='treeList.length == 0'>
              <el-option v-for="item in screenTypeData" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div style="margin: 0px 15px 5px 15px;">
            <el-input size="medium" placeholder="输入关键字进行过滤" v-model="filterText"> </el-input>
          </div>

          <div class="shengcheng" style="position: absolute;right: 5px;">
            <el-button type="primary" size="mini" @click="baobiao">批量增加</el-button>
            <el-button type="primary" size="mini" @click="qingkongxuanzhong">清空选中</el-button>
          </div>
          <div style="margin-bottom:10px;margin-left:13px;height: 30px;line-height: 30px;">设备列表</div>
          <el-scrollbar style="height:calc(100% - 175px);width: 100%;">
            <el-tree class="filter-tree" :data="treeList" show-checkbox node-key="keyId" :props="defaultProps2"
              :filter-node-method="filterNode" @check="currentChecked" @node-click="handleNodeClick" highlight-current
              ref="tree">
              <span class="custom-tree-node" slot-scope="{node}">
                <img src="../../../../public/static/image/elTree/1.9.png" style="margin-right: 2px;"
                  v-if="node.data.Content.Category && node.data.Content.Category == 'Organization'" />

                <img src="../../../../public/static/image/elTree/variable.png" style="margin-right: 2px;"
                  v-if="node.data.Content.variableName" />

                <img src="../../../../public/static/image/elTree/2.1.png"
                  style="margin-right: 2px; position: relative;top: 1px;"
                  v-if="node.data.Content.Category &&  node.data.Content.Category == 'Device'" />
                <span style="padding-left: 5px;">{{node.data.Content.Name}}</span>
              </span>
            </el-tree>
          </el-scrollbar>
        </div>
        <!-- 操作记录 -->
        <div class="record" v-show="activeIndex == 2">
          <el-scrollbar style="height:calc(100% - 15px);width: 100%;">
            <el-tree class="filter-tree" :data="recordList" :accordion="true" :default-expanded-keys="defaultExpanded"
              :current-node-key='defaultDevice' node-key="id" :props="defaultProps3" :highlight-current='true'
              @node-click="recordTreeClick" ref="temTree">
              <span class="custom-tree-node" slot-scope="{node}">
                <img src="../../../../public/static/image/elTree/1.9.png" style="margin-right: 5px;"
                  v-if="node.data.dataType == 0" />
                <img src="../../../../public/static/image/elTree/2.5.png"
                  style="margin-right: 5px; position: relative;top: 1px;" v-if="node.data.dataType == 1" />
                <span style="padding-left: 5px;">{{node.data.temName}}</span>
              </span>
            </el-tree>
          </el-scrollbar>
        </div>
      </el-col>
      <el-col :span="num" class="righted">
        <span class="el-icon-d-arrow-right" v-show="!flag" @click="flag=!flag;num=19;"></span>

        <el-scrollbar style="height:140px;width: 100%;">
          <div class="choice">
            <!-- 报表类型 -->
            <div class="choice-left">
              <div class="choice-title">报表类型</div>

              <div class="tyep-radio">
                <el-radio-group v-model="radioType" style="padding-top: 4px;">
                  <el-radio label="DAY" :disabled='Onecolumn'>日报</el-radio>
                  <el-radio label="MON" :disabled='Onecolumn'>月报</el-radio>
                  <dir style="margin:8px 0px"></dir>
                  <el-radio label="YEAR" :disabled='Onecolumn'>年报</el-radio>
                  <el-radio label="OTHER" :disabled='Onecolumn'>其他</el-radio>
                </el-radio-group>
              </div>

            </div>
            <!-- 变量定义 -->
            <div class="choice-middle">
              <div class="choice-title">变量定义</div>
              <div class="value-type">
                变量名称：<input type="text" style="height:13px;margin-right:10px" v-model="variableName" disabled>
                集合类型：<el-select v-model="collectionValue" placeholder="请选择" :disabled='nameDisabled'
                  style="width: 150px;">
                  <el-option v-for="item in collectionType" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-button type="primary" size="mini" style="margin-left:20px" @click="SUB_FN"
                  :disabled='saveFlag'>提交修改</el-button>
                <!-- 非集合只有差值不能选   横向跟纵向暂时就只能选原值差值平均值 -->
              </div>
              <div class="column-type">
                值 类 型：
                <el-radio-group v-model="radio" style="padding-top: 4px;" v-if="radioType != 'OTHER'">
                  <el-radio label="ORIGINAL">原值</el-radio>
                  <el-radio label="DIFFERENCE" v-show="isDisabled == 2 ">差值</el-radio>
                  <el-radio label="AVG">平均值</el-radio>
                  <el-radio label="MAX" v-show="isDisabled==1">最大值</el-radio>
                  <el-radio label="MIN" v-show="isDisabled==1">最小值</el-radio>
                  <el-radio label="MAX_TIME" v-show="isDisabled==1">最大值时间</el-radio>
                  <el-radio label="MIN_TIME" v-show="isDisabled==1">最小值时间</el-radio>
                </el-radio-group>
                <el-radio-group v-model="radio" style="padding-top: 4px;" v-if="radioType == 'OTHER'">
                  <el-radio label="ORIGINAL">原值</el-radio>
                  <el-radio label="DIFFERENCE">差值</el-radio>
                </el-radio-group>
              </div>
              <div style=" display: flex; align-items: center;margin-top:10px;height: 30px;"
                v-if="radioType != 'OTHER'">
                <div style="width:83px;"></div>
                <el-radio v-model="radio" label="DATE">报表时间</el-radio>
                <el-radio-group v-model="checkList" style="margin-left:35px" v-show="radioType !='YEAR'">
                  <el-radio label="CURRENT" v-show="collectionValue=='NON'">本{{radioType | valueTimeFil}}</el-radio>
                  <el-radio label="BEFORE" v-show="collectionValue=='NON'">上一{{radioType | valueTimeFil}}</el-radio>
                  <el-radio label="AFTER" v-show="collectionValue=='NON'">下一{{radioType | valueTimeFil}}</el-radio>
                  <el-radio label="SECTION" v-show="startTimeShow">开始时间</el-radio>
                </el-radio-group>
                <span style="margin-left:10px;margin-top: -5px;" class="tebie"
                  v-show="radioType !='YEAR' && startTimeShow2">{{radioType=='MON'?'日':'时'}}：</span>
                <el-select v-show="radioType !='YEAR' && startTimeShow2" v-model="startTime" placeholder="请选择"
                  style="width:70px;height: 30px;">
                  <el-option v-for="item in optionsMon" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <span style="margin-left:20px" v-show="radioType !='DAY' && differenceShow">差值起始时间：</span>
                <el-select v-show="radioType !='DAY' && differenceShow" v-model="differenceStartTime" placeholder="请选择"
                  style="width:70px;height: 30px;">
                  <el-option v-for="item in difference" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div style=" display: flex; align-items: center;margin-top:10px;height: 30px;"
                v-if="radioType == 'OTHER'">
                <div style="width:83px;"></div>
                <el-radio v-model="radio" label="DATE">报表时间</el-radio>
                <span style="margin-left:10px;margin-top: -5px;" class="tebie">开始时间：</span>
                <el-select v-model="differenceStartTime" placeholder="请选择" style="width:70px;height: 30px;">
                  <el-option v-for="item in optionsMon" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <span style="margin-left:10px;margin-top: -5px;" class="tebie"
                  v-show="radio =='DIFFERENCE'">结束时间：</span>
                <el-select v-model="differenceEndTime" placeholder="请选择" style="width:70px;height: 30px;"
                  v-show="radio =='DIFFERENCE'">
                  <el-option v-for="item in optionsMon" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="choice-right">
              <div class="choice-title">查询时间</div>
              <!-- 具体时间日月年 -->
              <div class="specific-timer">
                <span v-show="radioType != 'OTHER'">起始时间：</span>
                <el-date-picker v-model="specificTime" type="year" placeholder="选择年" v-show="radioType == 'YEAR'"
                  :picker-options="pickerOptionsUnit"></el-date-picker>
                <el-date-picker v-show="radioType == 'MON'" v-model="specificTime" type="month" placeholder="选择月"
                  :picker-options="pickerOptionsUnit"> </el-date-picker>
                <el-date-picker v-show="radioType == 'DAY'" v-model="specificTime" type="datetime" placeholder="选择日期时间"
                  align="right" :picker-options="pickerOptions"></el-date-picker>
                <el-date-picker class="mypicker" v-model="specificTime" v-show="radioType == 'OTHER'" type="daterange"
                  align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                  :picker-options="pickerOptionsOther"></el-date-picker>
              </div>
              <div class="look">
                <el-popover placement="bottom" width="160" v-model="visible">
                  <p style="color:#ff9900">获取数据后此操作记录不可再次修改与保存记录</p>
                  <div style="text-align: right; margin: 0">
                    <el-button size="mini" type="text" @click="visible = false">取消</el-button>
                    <el-button type="primary" size="mini" @click="queryExcel_fn">确定</el-button>
                  </div>
                  <el-button slot="reference" type="primary" size="small" :disabled="activeIndex==1">获取数据</el-button>
                </el-popover>
                <!-- <el-button type="primary" size="small" @click="queryExcel_fn">获取数据</el-button> -->
              </div>
            </div>
            <div class="choice-btns">
              <div class="choice-title">操作</div>
              <div class="btnsss">
                <el-button type="warning" size="small" @click="emptyExcel_fn">新建</el-button>
                <el-button type="primary" size="small" @click="addExcel_fn" :disabled='saveFlag'>保存</el-button>
                <el-button type="primary" size="small" @click="downloadExcel">导出</el-button>

              </div>

              <!-- 导入： <input style="font-size:16px;" type="file" @change="uploadExcel" /> -->

              <!-- <input style="font-size:16px;" type="file" @change="uploadExcel" /> -->
              <!-- <input style="font-size:16px;" type="file" id="Luckyexcel-demo-file" name="Luckyexcel-demo-file"
									@change="demoHandler" /> -->

            </div>
          </div>
        </el-scrollbar>


        <div id="luckysheet" ref="luckysheet"
          style="height: calc(100% - 135px);width: 100%;transform: translateY(-14px); margin-top:10px"
          @click="sheetMouseup"></div>
      </el-col>
    </el-row>

    <!-- 新增修改保存弹窗 -->
    <el-dialog v-dialogDrag title="报表" :close-on-click-modal='false' :visible.sync="dialogVisible" width="400" center>
      <div class="top-tree">
        <el-scrollbar style="height:calc(100% - 15px);width: 100%;">
          <el-tree class="filter-tree" :data="recordList" node-key="id" :props="defaultProps3"
            :default-expanded-keys="defaultExpanded" :current-node-key='defaultDevice' :highlight-current='true'
            @node-click="diaTreeClick" ref="diaTree">
            <span class="custom-tree-node" slot-scope="{node, data}" style="display: flex;align-items: center;">

              <img src="../../../../public/static/image/elTree/1.9.png" style="margin-right: 5px;"
                v-show="data.dataType == 0" />
              <img src="../../../../public/static/image/elTree/2.5.png"
                style="margin-right: 5px; position: relative;top: 1px;" v-show="data.dataType == 1" />
              <span style="padding-left: 5px;">{{data.temName}}</span>
              <!-- <input type="text" v-model="data.temName" style="padding-left: 5px;    border: 0;"> -->
              <span v-if="false">{{node}}</span>
              <div class="sh" v-show="visible1 == data.id">
                <el-tooltip class="item" effect="dark" content="新建目录" placement="top">
                  <i class="el-icon-folder-add" style="margin-left:40px;color:#67c23a;font-size: 20px;"
                    v-show="data.dataType == 0 && data.parentId ==0" @click="diaBtnFun('add')"></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="修改" placement="top">
                  <i class="el-icon-edit-outline" style="margin-left:15px;color:#ebb563;font-size: 20px;"
                    @click="diaBtnFun('edit')"></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="保存" placement="top">
                  <i class="el-icon-finished" style="margin-left:15px;color:#409eff;font-size: 20px;"
                    v-show="data.dataType == 0 && data.parentId !=0" @click="diaBtnFun('save')"></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除" placement="top">
                  <i class="el-icon-delete-solid" style="margin-left:15px;color:#f56c6c;font-size: 20px;"
                    @click="diaBtnFun('del')"></i>
                </el-tooltip>
              </div>
            </span>
          </el-tree>
        </el-scrollbar>
      </div>
      <div class="dia-input">
        <input type="text" placeholder="请输入名称" v-model="treeName">
        <el-button :type="dioBtn=='修改'?'warning':'primary'" size="small"
          @click="inputBtn(dioBtn)">{{dioBtn}}</el-button>
      </div>
      <div class="dia-input btnss">

      </div>
      <template #footer>
        <span class="dialog-footer">

        </span>
      </template>
    </el-dialog>

    <!-- 遮罩层 -->
    <!-- <div class="mask" v-if="isMask">
      <i class="el-icon-loading" style="color:#409eff;font-size:60px"></i>
    </div> -->
  </div>
</template>
<script>
  // import { GetExcelTemplateDirectorieXlsx } from "@/utils/request";
  import {GetExcelTemplateDirectorieXlsx} from "../../../api/abbNewApi";
  import {statementVariableTree,statementAppTypeGroup,statementSave,statementFindById,statementFindTree,statementfindDataByCatalogueId,statementDeleteById,statementVariableData} from "../../../api/newReport";
  import LuckyExcel from "luckyexcel";
  import $ from 'jquery';
  import axios from 'axios'
  // import { exportExcel } from "@/utils/export"; /*导出*/
  import {parseTime} from "@/utils";
  import waves from '../../../components/module/directive/waves' // waves directive
  import elRadioTree from '@/components/module/tree/elRadioTree.vue'
  import tagsView from "./tagsView"
  import {testaaa,exportExcel} from './export'
  import * as echarts from "echarts";
  // import {exportSheetExcel} from './exceljs'
  export default {
    directives: {waves},
    components: {
      elRadioTree
    },
    data () {
      var validateName=(rule,value,callback) => {

        if(!value) {
          callback(new Error('请点击左侧树形选择报表'));
          this.$message.info('请点击左侧树形选择报表')
        } else {
          callback();
        }
      };
      return {
        dataListCopy: [],
        copyCelldata: [],
        isMask: false,//遮罩层
        visible1: "", // 本身id
        dataType: 0,//树形结构类型
        dataTypeId: 0,
        startTimeShow2: true,
        saveFlag: false,//获取数据后不可再次保存
        recordFlag: false,//判断是否获取了操作记录
        visible: false,//获取数据提示框
        radioType: "DAY",
        startTime: 0,//开始时间
        differenceStartTime: 0,
        differenceEndTime: 1,//其他报表结束时间
        endTime: "",//开始时间
        optionsMon: [],//月份下拉框
        difference: [],//计算差值下拉框
        differenceShow: false,
        differenceStartTime: 0,//计算差值的起始时间（小时）
        variableName: "", //变量名称
        diaFlag: false,//弹窗输入框显示隐藏
        dialogVisible: false,//弹窗
        Btndisabled: true,//按钮禁用
        dioName: "",//弹窗输入框
        dioBtn: "新增",//弹窗输入框右边按钮
        shouMenu: false, //选择企业显示隐藏
        activeIndex: 2, //高亮选项卡
        checkList: "CURRENT",
        radio: 'ORIGINAL', //值类型
        isDisabled: 1, //值类型
        nameDisabled: false,
        //横向纵向
        optionsType: [{
          value: '选项1',
          label: '横向'
        },{
          value: '选项2',
          label: '纵向'
        }],
        //日月年
        optionsTime: [{
          value: 'DAY',
          label: '日'
        },{
          value: 'MON',
          label: '月'
        },{
          value: 'YEAR',
          label: '年'
        }],
        valueType: '横向',//表类型
        //集合类型
        collectionType: [{
          value: 'NON',
          label: '非集合单值'
        },{
          value: 'CROSSWISE',
          label: '横向'
        },{
          value: 'LENGTHWAYS',
          label: '纵向'
        }],
        //集合类型数据
        collectionValue: "NON",
        startTimeShow: false,
        specificTime: "", //具体时间
        //选择月份时间选择器
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          },
          shortcuts: [{
            text: '今天',
            onClick (picker) {
              picker.$emit('pick',new Date());
            }
          },{
            text: '昨天',
            onClick (picker) {
              const date=new Date();
              date.setTime(date.getTime()-3600*1000*24);
              picker.$emit('pick',date);
            }
          },{
            text: '一周前',
            onClick (picker) {
              const date=new Date();
              date.setTime(date.getTime()-3600*1000*24*7);
              picker.$emit('pick',date);
            }
          }]
        },
        //限制不能选今天之后的时间
        pickerOptionsUnit: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          },
        },
        thisId: '',
        search: {
          date: new Date(),
          isAfferentTime: true
        },

        value2: '',
        rules: {
          name: [
            {validator: validateName,trigger: 'blur'}
          ],
          date: [
            {required: true,message: '请选择时间',trigger: 'change'}
          ],

        },
        options: {
          container: "luckysheet",
          title: "exceledit", //表 头名
          lang: "zh", //中文
          showtoolbar: true, //是否显示工具栏
          showinfobar: false, //是否显示顶部信息栏
          showsheetbar: false, //是否显示底部sheet按钮
          myFolderUrl: "/",//作用：左上角<返回按钮的链接
          plugins: ['chart'],
          column: 30,
          row: 100,
          allowEdit: true,//是否允许前端编辑
          image: true,
          chart: true,
          exportC: true,
          forceCalculation: true, //强制刷新公式
          cellRightClickConfig: {//自定义配置单元右键菜单
            copy: true, // 复制
            copyAs: true, // 复制为
            paste: true, // 粘贴
            insertRow: true, // 插入行
            insertColumn: true, // 插入列
            deleteRow: true, // 删除选中行的数据 
            deleteColumn: true, // 删除选中列的数据
            deleteCell: true,
            hideRow: true,
            hideColumn: true,
            rowHeight: true, // 设置行高
            columnWidth: true, // 设置行宽
            clear: true, // 清空选定内容
            matrix: false, //矩阵 
            sort: true, // 排序
            filter: true, //筛选 
            chart: true, //图表生成
            image: true, //插入图片
            link: true, // 插入连接，比如网址之类
            data: true, //数据校验
            cellFormat: true //设置单元格格式，锁定单元格格式，隐藏公示等
          },


        },
        num: 20,
        //设备变量树形结构
        treeList: [],
        //操作记录树形结构
        recordList: [],
        flag: true,//显示树形
        filterText: '',
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        defaultProps2: {
          children: 'ChildDatas',
          label: 'Content.Name'
        },
        defaultProps3: {
          children: 'children',
          label: 'temName',
        },
        enterpriseID: "",//企业树形id
        enterpriseName: "-- 选择企业 --",
        screenTypeData: null,
        screenTypevalue: "",
        treeListCopy: null,
        checkedNodes: [],
        halfCheckedNodes: null,
        recordId: "",
        treeName: "",
        leftRecordId: "",
        leftRecordName: "",
        dataFlag: false, //判断选中的是否是操作记录
        treeClickCount: 0, //判断树形结构是否双击
        dataOneConunt: 0,//判断第一次添加变量是在哪一位置
        Onecolumn: false,//第一次出现的位置,
        nowStemItem: [],//默认展开的操作记录
        defaultExpanded: [],
        defaultDevice: "",
        pickerOptionsOther: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          },
          shortcuts: [
            {
              text: '最近一周',
              onClick (picker) {
                const end=new Date();
                const start=new Date();
                start.setTime(start.getTime()-3600*1000*24*7);
                picker.$emit('pick',[start,end]);
              }
            },{
              text: '最近一个月',
              onClick (picker) {
                const end=new Date();
                const start=new Date();
                start.setTime(start.getTime()-3600*1000*24*30);
                picker.$emit('pick',[start,end]);
              }
            }]
        },
        optionsCopy: {},
        loading: true

      };
    },
    watch: {
      filterText (val) {
        this.$refs.tree.filter(val);
      },
      //筛选类型
      screenTypevalue (val) {
        this.screenType_fn(val)
        // this.$refs.tree.filter(val);
      },
      dialogVisible () {
        this.diaFlag=false
        this.Btndisabled=true
        this.dioName=''
        this.dioBtn='新增'
      },
      radioType (val) {

        this.specificTime=""
        this.startTime=0
        this.checkList='CURRENT'
        this.optionsMon=[]

        if(val=='MON') {
          this.startTime=1
          for(let i=0;i<31;i++) {

            this.optionsMon.push({
              'value': i+1,
              'label': i+1+'号'
            })

          }
        } else if(val=='DAY'||val=='OTHER') {
          for(let i=0;i<24;i++) {
            this.optionsMon.push({
              'value': i,
              'label': i+'点'
            })
          }

        }
        if(val=='OTHER') {
          this.collectionType=[{
            value: 'CROSSWISE',
            label: '横向'
          },{
            value: 'LENGTHWAYS',
            label: '纵向'
          }]
          this.collectionValue='CROSSWISE'
        } else {
          this.collectionType=[{
            value: 'NON',
            label: '非集合单值'
          },{
            value: 'CROSSWISE',
            label: '横向'
          },{
            value: 'LENGTHWAYS',
            label: '纵向'
          }]
          this.collectionValue='NON'
        }


      },
      //集合类型
      collectionValue (val) {

        if(this.radioType=='MON') {
          if(val=='CROSSWISE'||val=='LENGTHWAYS') {
            this.isDisabled=2
            this.startTimeShow=true
            if(this.radio=='DIFFERENCE') {
              this.differenceShow=true
            }
          } else {
            this.isDisabled=1
            this.startTimeShow=false
            this.differenceShow=false
          }

        } else {
          if(val=='NON') {
            this.isDisabled=1
            this.differenceShow=false
          } else if(val=='CROSSWISE'||val=='LENGTHWAYS') {
            this.isDisabled=2
            if(this.radio=='DIFFERENCE') {
              this.differenceShow=true
            }
          }
        }

      },
      //单选框
      radio (val) {
        if(val=='DATE') {
          this.nameDisabled=true
          this.variableName='DATE'
        } else {
          this.nameDisabled=false
          // this.variableName = ''
        }
        if(val=='AVG'||val=='MAX'||val=='MIN'||val=='MAX_TIME'||val=='MIN_TIME') {
          this.startTimeShow2=false
          // this.startTimeShow = false
          this.checkList='CURRENT'
          this.startTime=1
        } else {
          this.startTimeShow2=true
          // this.startTimeShow = true
        }
        if(val=='DIFFERENCE') {
          this.differenceShow=true
        } else {
          this.differenceShow=false
        }
      },
      //单位树形结构
      dataListCopy (val) {
        if(val.length!=0) {
          this.enterpriseNodeClick(val[0])
        }
      }


    },
    computed: {

      virtualDeviceList () {
        var data=this.$store.unitStore.getters.getUnitTree
        return isempty(data)? []:[unitList(data)]
      },
      dataList () {
        var data=this.$store.unitStore.getters.getUnitTree
        this.dataListCopy=isempty(data)? []:[unitList(data)]
        return isempty(data)? []:[unitList(data)]
      },
    },
    mounted () {
      for(let i=0;i<24;i++) {
        this.optionsMon.push({
          'value': i,
          'label': i+'点'
        })
      }
      // console.log("尝试",userManagerStore.state.shieldArray);
      // this.bbb()
      // this.handleData()
      $(() => {luckysheet.create(this.options);}); /*渲染*/
      // GetExcelTemplateDirectorieXlsx().then(res => {
      if(!isempty(this.dataList)) {
        this.defaultUnitId=this.dataList[0].id
      }
      statementAppTypeGroup().then(res => {
        // console.log("类型",res);
        if(res.code==200) {
          this.screenTypeData=res.data
        }
      })
      this.difference=[]
      this.statementFindTreeFun() //获取操作记录
      for(let i=0;i<24;i++) {
        this.difference.push({
          'value': i,
          'label': i
        })
      }
      // this.treeList  = this.makeTree([res.Response]); 
      // })
    },
    created () {
      localStorage.setItem("shieldArray",1)
    },
    methods: {
      //清空选中的设备列表
      qingkongxuanzhong () {
        this.$refs.tree.setCheckedKeys([]);
      },
      //清空excel表
      emptyExcel_fn () {
        this.$confirm('此操作将新建新的表格, 是否继续?','提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.Onecolumn=false
          this.saveFlag=false
          this.dataOneConunt=0
          var sheet=luckysheet.getAllSheets()[0]
          // console.log(sheet);
          sheet.celldata=[]
          sheet.calcChain=[]
          sheet.chart=[]
          sheet.images=[]
          delete sheet.images
          sheet.config={}
          window.luckysheet.destroy();
          this.options.data=[sheet];
          window.luckysheet.create(this.options);
          this.$message({
            type: 'success',
            message: '清空成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消清空'
          });
        });


      },
      //转换列定义名称
      transName (name) {
        if(name=='avgValue') {
          return "平均值"
        } else if(name=='maxValue') {
          return "最大值"
        } else if(name=='maxValueTime') {
          return "最大值时间"
        } else if(name=='minValue') {
          return "最小值"
        } else if(name=='minValueTime') {
          return "最小值时间"
        } else {
          return name
        }
      },
      //处理值类型是否选中报表时间
      DATE_FN (type,name) {
        if(type=='DATE') {
          return 'DATE'
        } else {
          return name
        }
      },
      //提交修改
      SUB_FN () {
        // console.log("提交修改");

        var sheet=luckysheet.getAllSheets()[0]
        var b=sheet.luckysheet_select_save
        var r=b[0].row[0]
        var c=b[0].column[0]
        var xuanzhong=sheet.celldata.filter(item => item.r==r&&item.c==c)
        if(xuanzhong.length==0) {
          this.$message({message: '请选择单元格',type: 'warning'});
        }
        var d={
          "r": r,
          "c": c,
          "v": {
            "ct": {
              "fa": "##0.00",
              "t": "n"
            },
            "fs": 10,
            "ff": "宋体",
            "bl": 0,
            "ht": 0,
            "vt": 0,
            "tb": 1,
            "v": "",
            "qp": 1,
            'ps': {
              "height": null,
              "isshow": false,
              "left": null,
              "top": null,
              "value": this.DATE_FN(this.radio,xuanzhong[0].v.ps.value),
              "parameter": {
                'differenceStartTime': this.differenceStartTime,
                'valueType': this.RADIO_FN(this.radio),
                'typeSet': this.collectionValue,
                'variablesName': this.DATE_FN(this.radio,xuanzhong[0].v.ps.value),
                'x': c,
                'y': r,
                'startTime': this.startTime,
                'timeOfValue': this.checkList
              },
              "width": null
            }
          }
        }
        if(this.radioType=='OTHER'&&this.radio=='DIFFERENCE') {
          d.v.ps.parameter.differenceEndTime=this.differenceEndTime
        }
        let index=sheet.celldata.findIndex(item => item.r==r&&item.c==c)
        // console.log(index);
        sheet.celldata.splice(index,1,d)
        window.luckysheet.destroy();
        this.options.data=[sheet];
        window.luckysheet.create(this.options);

        // console.log(luckysheet.getAllSheets()[0]);

      },
      //处理单选框
      RADIO_FN (type) {
        if(type=='DATE') {
          return 'ORIGINAL'
        } else {
          return type
        }
      },
      //鼠标单点单元格
      sheetMouseup () {
        var sheet=luckysheet.getAllSheets()[0]
        var b=sheet.luckysheet_select_save
        var r=b[0].row[0]
        var c=b[0].column[0]
        var xuanzhong=sheet.celldata.filter(item => item.r==r&&item.c==c)
        if(xuanzhong.length==0) {
          this.variableName=''
          return
        }
        // xuanzhong[0].v.v = 20
        // xuanzhong[0].v.m = 20
        if(!xuanzhong[0].v.hasOwnProperty('ps')) {
          this.variableName=''
          return
        }
        // this.variableName =   this.DATE_FN(xuanzhong[0].v.ps.parameter.valueType,xuanzhong[0].v.ps.value)
        this.radio=xuanzhong[0].v.ps.parameter.valueType
        this.collectionValue=xuanzhong[0].v.ps.parameter.typeSet
        this.checkList=xuanzhong[0].v.ps.parameter.timeOfValue
        this.startTime=xuanzhong[0].v.ps.parameter.startTime
        this.differenceStartTime=xuanzhong[0].v.ps.parameter.differenceStartTime
        // if(xuanzhong[0].v.ps.parameter.differenceEndTime){
        this.differenceEndTime=xuanzhong[0].v.ps.parameter.differenceEndTime
        // }

        // console.log("点击单元格",xuanzhong, xuanzhong[0].v.ps.value);
        setTimeout(() => {
          this.variableName=xuanzhong[0].v.ps.value
        },200)


      },
      //单元格宽度(根据字符来确定宽度)
      dynamicWidth (str) {
        return str.length>7? 10*str.length:70
      },
      //查询(表格数据)
      queryExcel_fn () {
        // console.log(this.radio);
        if(this.specificTime=='') {
          this.$message({message: '请选择起始时间',type: 'warning'});
          return
        }
        if(!this.recordFlag) {
          this.$message({message: `请选择操作记录`,type: 'warning'});
          return
        }
        var sheet=luckysheet.getAllSheets()[0]

        sheet.config['columnlen']={}
        //去掉之前的数据
        sheet=JSON.parse(JSON.stringify(this.copyCelldata))
        // var accordArr = sheet.celldata.filter(item => item.c == this.Onecolumn)
        var newAccordArr=sheet.celldata.filter(item => item.v.hasOwnProperty('ps'))
        sheet.celldata=sheet.celldata.filter(item => !item.v.hasOwnProperty('temporary'))

        // console.log("temporary",temporary);
        // var minVal = Math.min.apply(Math, newAccordArr.map(item => item.r))
        var a=[]
        newAccordArr.forEach(item => {
          item.v.ps.parameter.y=item.r
          a.push(item.v.ps.parameter)
        })
        if(a.length==0) {
          this.$message({message: '请添加变量再获取数据',type: 'warning'});
          return
        }
        var d={
          // 'searchTime':new Date(this.specificTime).getTime(),
          'dateType': this.radioType,
          'variables': a
        }
        if(this.radioType=='OTHER') {
          d.searchTime=new Date(this.specificTime[0]).getTime()
          d.endTime=new Date(this.specificTime[1]).getTime()
        } else {
          d.searchTime=new Date(this.specificTime).getTime()
        }
        // console.log(d);

        //   r ==y
        //   c==x
        this.isMask=true


        statementVariableData(d).then(res => {
          this.visible=false
          if(res.code==200) {
            this.saveFlag=true
            res.data.forEach((item) => {

              if(item) {
                if(item.typeSet=='LENGTHWAYS') {
                  item.values.forEach((t,i) => {
                    sheet.celldata.push({
                      "r": item.y+i,
                      "c": item.x,
                      "v": {
                        "ct": {
                          "fa": "##0.00",
                          "t": "n"
                        },
                        "fs": 10,
                        "ff": "宋体",
                        "bl": 0,
                        "ht": 0,
                        "vt": 0,
                        "tb": 1,
                        // "v":this.transName(res.data[key].values[item]),
                        "v": t+'',
                        "qp": 1,
                        "temporary": 1
                      }
                    })
                    //    sheet.config.columnlen[`${item.y+i}`] =this.dynamicWidth(t)
                  })
                } else {
                  item.values.forEach((t,i) => {
                    sheet.celldata.push({
                      "r": item.y,
                      "c": item.x+i,
                      "v": {
                        "ct": {
                          "fa": "##0.00",
                          "t": "n"
                        },
                        "fs": 10,
                        "ff": "宋体",
                        "bl": 0,
                        "ht": 0,
                        "vt": 0,
                        "tb": 1,
                        // "v":this.transName(res.data[key].values[item]),
                        "v": t+'',
                        "qp": 1,
                        "temporary": 1
                      }
                    })
                    //    sheet.config.columnlen[`${item.x+i}`] =this.dynamicWidth(t)
                  })
                }
              }

            })



            // window.luckysheet.destroy();


            this.options.data=[sheet];
            window.luckysheet.create(this.options);

            setTimeout(() => {
              console.log("执行");
              var final=luckysheet.getluckysheetfile()
              var chartArr=final[0].chart
              if(chartArr) {

                chartArr.forEach(item => {
                  item.chartOptions.chartData=this.tranChartData(item,0)
                  item.chartOptions.chartDataCache.series=item.chartOptions.defaultOption.seriesData=this.tranChartData(item,1)
                  item.chartOptions.defaultOption.series.forEach((t,i) => {
                    t.data=item.chartOptions.chartDataCache.series[i]
                  })
                })
                this.options.data=final
                window.luckysheet.create(this.options);
              }
              this.isMask=false;
            },2000)




          } else {
            this.isMask=false;
            this.$message({message: `获取失败${res.message}`,type: 'error'});
          }

        })
        // for(let k in res.data){
        // 	console.log(k,res.data[k]);
        // }
        // exportSheetExcel(luckysheet.getluckysheetfile(), "报表名称");
      },

      //双击添加变量点击设备列表树形结构
      handleNodeClick (data) {
        console.log("data",data);
        // var a = data.Content.variableName
        var a=data.Content.hasOwnProperty('variableName')
        if(!this.startTime) {
          this.startTime=0
        }
        this.treeClickCount++

        if(this.treeClickCount>2) return

        setTimeout(() => {
          // console.log(data.Content.variableName);
          var sheet=luckysheet.getAllSheets()[0]
          // console.log(sheet);
          var b=sheet.luckysheet_select_save
          var r=b[0].row[0]
          var c=b[0].column[0]
          var d={
            "r": r,
            "c": c,
            "v": {
              "ct": {
                "fa": "##0.00",
                "t": "n"
              },
              "fs": 10,
              "ff": "宋体",
              "bl": 0,
              "ht": 0,
              "vt": 0,
              "tb": 1,
              "v": "",
              "qp": 1,
              'ps': {
                "height": null,
                "isshow": false,
                "left": null,
                "top": null,
                "value": this.DATE_FN(this.radio,data.Content.variableName),
                "parameter": {
                  'differenceStartTime': this.differenceStartTime,
                  'valueType': this.RADIO_FN(this.radio),
                  'typeSet': this.collectionValue,
                  'variablesName': this.DATE_FN(this.radio,data.Content.variableName),
                  'x': c,
                  'y': r,
                  'startTime': this.startTime,
                  'timeOfValue': this.checkList
                },
                "width": null
              }
            }
          }
          if(this.treeClickCount==2) {
            // 进行双击事件处理
            if(a) {

              this.dataOneConunt++
              sheet.celldata.forEach((item,index) => {
                // console.log(item);
                if(item.r==r&&item.c==c) {
                  // console.log("有相同需要替换",index);
                  sheet.celldata.splice(index,1)
                }


              })
              if(this.radioType=='OTHER'&&this.radio=='DIFFERENCE') {
                d.v.ps.parameter.differenceEndTime=this.differenceEndTime
              }
              sheet.celldata.push(d)
              window.luckysheet.destroy();
              this.options.data=[sheet];
              window.luckysheet.create(this.options);
              if(this.dataOneConunt<2) {
                this.Onecolumn=true
              }
            }

          }
          this.treeClickCount=0
        },300)


      },
      //批量添加
      baobiao () {
        //  this.$refs.tree.setCheckedKeys([]);
        var sheet=luckysheet.getAllSheets()[0]
        // console.log(sheet);
        var b=sheet.luckysheet_select_save
        var r=b[0].row[0]
        var c=b[0].column[0]
        // console.log("c",c);
        if(this.checkedNodes.length==0) {
          this.$message({message: '请选择变量',type: 'warning'});
          return
        }
        this.checkedNodes.forEach((item,index) => {
          sheet.celldata.forEach((t,i) => {
            // console.log(item);
            if(t.r==r+index&&t.c==c) {
              // console.log("有相同需要替换",index);
              sheet.celldata.splice(i,1)
            }

          })
          // console.log("123",item.Content.variableName);
          if(this.collectionValue=='LENGTHWAYS') {
            var d={
              "r": r,
              "c": c+index,
              "v": {
                "ct": {
                  "fa": "##0.00",
                  "t": "n"
                },
                "fs": 10,
                "ff": "宋体",
                "bl": 0,
                "ht": 0,
                "vt": 0,
                "tb": 1,
                "v": "",
                "qp": 1,
                'ps': {
                  "height": null,
                  "isshow": false,
                  "left": null,
                  "top": null,
                  "value": this.DATE_FN(this.radio,item.Content.variableName),
                  "parameter": {
                    'differenceStartTime': this.differenceStartTime,
                    'valueType': this.RADIO_FN(this.radio),
                    'typeSet': this.collectionValue,
                    'variablesName': this.DATE_FN(this.radio,item.Content.variableName),
                    'x': c+index,
                    'y': r,
                    'startTime': this.startTime,
                    'timeOfValue': this.checkList

                  },
                  "width": null
                }
              }
            }
            if(this.radioType=='OTHER'&&this.radio=='DIFFERENCE') {
              d.v.ps.parameter.differenceEndTime=this.differenceEndTime
            }
            sheet.celldata.push(d)
          } else {
            var d={
              "r": r+index,
              "c": c,
              "v": {
                "ct": {
                  "fa": "##0.00",
                  "t": "n"
                },
                "fs": 10,
                "ff": "宋体",
                "bl": 0,
                "ht": 0,
                "vt": 0,
                "tb": 1,
                "v": "",
                "qp": 1,
                'ps': {
                  "height": null,
                  "isshow": false,
                  "left": null,
                  "top": null,
                  "value": this.DATE_FN(this.radio,item.Content.variableName),
                  "parameter": {
                    'differenceStartTime': this.differenceStartTime,
                    'valueType': this.RADIO_FN(this.radio),
                    'typeSet': this.collectionValue,
                    'variablesName': this.DATE_FN(this.radio,item.Content.variableName),
                    'x': c,
                    'y': r+index,
                    'startTime': this.startTime,
                    'timeOfValue': this.checkList

                  },
                  "width": null
                }
              }
            }
            if(this.radioType=='OTHER'&&this.radio=='DIFFERENCE') {
              d.v.ps.parameter.differenceEndTime=this.differenceEndTime
            }
            sheet.celldata.push(d)
          }


        })

        this.dataOneConunt++

        window.luckysheet.destroy();
        this.options.data=[sheet];
        window.luckysheet.create(this.options);

        if(this.dataOneConunt<2) {
          this.Onecolumn=true
        }
      },
      //双击操作记录操作记录树形结构
      recordTreeClick (node) {
        this.leftRecordId=node.id
        this.leftRecordName=node.temName
        this.treeClickCount++
        if(this.treeClickCount>2) return

        setTimeout(() => {
          if(this.treeClickCount==2) {
            this.saveFlag=false
            // 进行双击事件处理
            var aaa=[]
            this.isMask=true
            this.nowStemItem=[node.id]
            statementFindById({"id": this.leftRecordId}).then(res => {
              console.log("查询",res);
              if(res.code==200) {

                if(res.data==null) {
                  this.$message({message: `请选择操作记录`,type: 'warning'});
                  this.isMask=false
                  return
                }
                if(res.data.content!='') {

                  aaa.push(JSON.parse(res.data.content))
                  //处理绑定时候
                  var newAccordArr=aaa[0].celldata.filter(item => item.v.hasOwnProperty('ps'))
                  newAccordArr.forEach(item => item.v.ps.parameter.y=item.r)

                  window.luckysheet.destroy();
                  this.options.data=aaa;
                  console.log("this.options",aaa);
                  this.copyCelldata=JSON.parse(JSON.stringify(this.options.data[0]))
                  window.luckysheet.create(this.options);
                  this.recordFlag=true
                  this.radioType=res.data.dateType
                  this.Onecolumn=true
                  this.isMask=false
                } else {
                  this.isMask=false
                  this.$message({message: `此${this.leftRecordName}报表暂无数据`,type: 'warning'});
                }
              }

            })

          }
          this.treeClickCount=0
        },300)
      },

      //弹窗按钮操作
      diaBtnFun (type) {
        // console.log(type);
        if(type=='add') {
          this.diaFlag=true
          this.dioBtn='新增'
        } else if(type=='edit') {
          this.diaFlag=true
          this.dioBtn='修改'
        } else if(type=='del') {

          // if(this.treeName == ''){
          // 	this.$message({ message: '请选择需要删除的目录或者数据节点', type: 'warning' });
          // 	return
          // }
          this.$confirm(`是否删除此${this.treeName}`,'提示',{
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            statementDeleteById({'id': this.visible1}).then(res => {
              if(res.code==200) {
                this.statementFindTreeFun()
                this.$message({message: '删除成功',type: 'success'});
              } else {
                this.$message({message: `删除失败,${res.message}`,type: 'error'});
              }
            })

          }).catch(() => {
            // ...
          });;
        } else if(type=='save') {
          this.diaFlag=true
          this.dioBtn='保存'
          this.dioName=""

        }
      },


      //子节点懒加载
      loadNode (node,resolve) {
        if(node.level===0) {
          return resolve([{temName: '请新建目录'}]);
        }
        if(node.level>2) return resolve([]);
        statementfindDataByCatalogueId({'id': node.data.id}).then(res => {
          if(res.code==200) {
            resolve(res.data);
          } else {
            this.$message({message: `获取失败,${res.message}`,type: 'warning'});
          }
        })
      },

      //弹窗输入框右边按钮
      inputBtn (type) {
        if(this.treeName=='') {
          this.$message({message: '请输入名称',type: 'warning'});
          return
        }
        var name=this.treeName
        if(name.indexOf("/")>=0||name.indexOf("*")>=0||name.indexOf(":")>=0||name.indexOf("[")>=0||name.indexOf("]")>=0||name.indexOf("?")>=0) {
          this.$message({message: '名称不能包含以下任何字符 * ? : \ / [ ]',type: 'warning'});
          return
        }
        // if(type == '新增'){

        // }
        var d={}
        if(type=='新增') {
          if(this.recordList.length==0) {
            //树形结构没有一个数据时新建一级目录
            // console.log("没有",0);
            d={
              "content": "",
              "dataType": 0,
              "parentId": 0,
              "temName": this.treeName,
              "uid": 0
            }
          } else {
            // console.log("有",this.recordId);
            d={
              "content": "",
              "dataType": 0,
              "parentId": this.recordList[0].id,
              "temName": this.treeName,
              "uid": 0
            }
          }
        } else if(type=='修改') {
          var a=luckysheet.getAllSheets()[0]
          var newAccordArr=a.celldata.filter(item => item.v.hasOwnProperty('ps'))
          newAccordArr.forEach(item => {
            item.v.ps.parameter.y=item.r
          })

          a.name=this.treeName
          //图表位置大小更新
          var chartArr=a.chart
          if(chartArr!=undefined) {
            var chartHtml=[]
            chartArr.forEach(item => {
              chartHtml.push(document.querySelector(`#${item.chart_id}_c`))
            })

            chartHtml.forEach((t,i) => {
              chartArr[i].width=Number((t.style.width).replace(/px/g,""))
              chartArr[i].height=Number((t.style.height).replace(/px/g,""))
              chartArr[i].top=Number((t.style.top).replace(/px/g,""))
              chartArr[i].left=Number((t.style.left).replace(/px/g,""))
            })
          }
          d={
            "content": "",
            "dataType": this.dataType,
            "parentId": this.recordId,
            'dateType': this.radioType,
            "temName": this.treeName,
            "uid": this.visible1
          }
          if(this.dataType==1) {
            d.content=JSON.stringify(a)
            // d.dateType = this.radioType
          } else {
            d.content=""
          }
        } else if(type==='保存') {
          var a=luckysheet.getAllSheets()[0]
          var newAccordArr=a.celldata.filter(item => item.v.hasOwnProperty('ps'))
          newAccordArr.forEach(item => {
            item.v.ps.parameter.y=item.r
          })
          a.name=this.treeName
          var chartArr=a.chart
          //图表位置大小更新
          if(chartArr!=undefined) {
            var chartHtml=[]
            chartArr.forEach(item => {
              chartHtml.push(document.querySelector(`#${item.chart_id}_c`))
            })

            chartHtml.forEach((t,i) => {
              chartArr[i].width=Number((t.style.width).replace(/px/g,""))
              chartArr[i].height=Number((t.style.height).replace(/px/g,""))
              chartArr[i].top=Number((t.style.top).replace(/px/g,""))
              chartArr[i].left=Number((t.style.left).replace(/px/g,""))
            })
          }
          var id=0

          if(this.dataType==0) {
            this.recordId=this.dataTypeId
          } else if(this.dataType==1) {
            var id=this.visible1
          }

          d={
            "content": JSON.stringify(a),
            "dataType": 1,
            'dateType': this.radioType,
            "parentId": this.recordId,
            "temName": this.treeName,
            "uid": id
          }

        }
        statementSave(d).then(res => {
          if(res.code==200) {
            this.treeName=""
            this.diaFlag=false
            this.$message({message: `${type}成功`,type: 'success'});
            this.statementFindTreeFun()
          } else {
            this.$message({message: `${type}失败,${res.message}`,type: 'warning'});
          }
        })
      },
      //弹窗树形结构被点击
      diaTreeClick (a) {
        // console.log(a);

        this.visible1=a.id //本身id
        this.Btndisabled=false
        this.treeName=a.temName //输入框名称
        this.recordId=a.parentId //父级id
        this.dataType=a.dataType //树形类型(目录/数据)
        if(a.dataType==1) { //第三级也就是数据
          this.dataFlag=true
        } else {
          this.dataTypeId=a.id
          this.dataFlag=false
        }
        // if(this.dioBtn == '修改'){
        // 	this.dioName  = a.temName
        // }
      },
      //根据id获取操作记录目录树
      statementFindTreeFun () {
        statementFindTree().then(res => {
          if(res.code==200) {
            this.recordList=res.data
            if(this.recordList.length==0) {
              this.diaBtnFun("add")
            } else {
              this.operateTree_fn(res.data[0].id,0)

            }
          }
        })
      },
      //操作记录树默认选中
      operateTree_fn (id,type) {
        if(this.nowStemItem.length==0) {
          this.defaultExpanded=[id]
          this.defaultDevice=id
        } else {
          this.defaultExpanded=this.nowStemItem
          this.defaultDevice=this.nowStemItem[0]
        }
        this.$nextTick(() => {
          //默认选中
          if(type==0) {
            this.$refs['temTree'].setCurrentKey(this.defaultDevice);
          } else {
            this.$refs['diaTree'].setCurrentKey(this.defaultDevice);
          }
        })
      },
      //点击操作记录选项卡
      recordFun () {
        this.activeIndex=2

      },



      //转换时间格式
      changeTimeFormat (str) {
        this.clock=(str+'').split(' ')[4]
        if((str+'').indexOf('-')!=-1) {
          str=str.replace(new RegExp(/-/gm),'/')
        }
        let d=new Date(str)
        let newDateYear=d.getFullYear()
        let newDateMonth=(d.getMonth()+1)<10? '0'+(d.getMonth()+1):(d.getMonth()+1)
        let newDateDay=d.getDate()+''<10? '0'+d.getDate()+'':d.getDate()+''
        if(this.radioType=='DAY') {

          return newDateYear+'-'+newDateMonth+'-'+newDateDay
        } else if(this.radioType=='MON') {
          return newDateYear+'-'+newDateMonth
        } else if(this.radioType=='YEAR') {
          return newDateYear
        }
      },
      //转换图表数据
      tranChartData (obj,type) {
        // console.log("需要遍历的",obj);
        var c1=type==0? obj.chartOptions.rangeArray[0].column[0]:obj.chartOptions.rangeArray[0].column[0]+1
        var c2=obj.chartOptions.rangeArray[0].column[1]
        var r1=type==0? obj.chartOptions.rangeArray[0].row[0]:obj.chartOptions.rangeArray[0].row[0]+1
        var r2=obj.chartOptions.rangeArray[0].row[1]
        var chartData=[];
        var cellObj=0
        for(var i=r1;i<=r2;i++) {
          var row=[];
          for(var j=c1;j<=c2;j++) {
            var cellValue=luckysheet.getCellValue(i,j);
            if(cellValue) {
              if(type==0) {
                cellObj={
                  'ct': {
                    'fa': "General",
                    't': "g"
                  },
                  'm': cellValue,
                  'v': Number(cellValue),
                }
              } else if(type==1) {
                cellObj=Number(cellValue)
              }
            } else {
              cellObj=type==0? cellValue:0
            }

            // if(cellValue){
            // 	cellObj = Number(cellValue)
            // }else {
            // 	cellObj = 0
            // }
            row.push(cellObj);
          }
          chartData.push(row);
        }
        // console.log("表格数据12343",chartData);
        return chartData
      },

      //导出
      downloadExcel () {
        var sheet=luckysheet.getAllSheets()[0]
        var sheetChart=sheet.chart
        var sheetImgObj=sheet.images
        var chartObj={}
        var final=luckysheet.getluckysheetfile()
        let mycanvas=document.getElementsByTagName('canvas')
        if(sheetChart!=undefined&&sheetChart.length!=0) {
          sheetChart.forEach((item,index) => {
            chartObj[item.chart_id]={
              'border': {
                "color": "#000",
                "radius": 0,
                "style": "solid",
                "width": 0,
              },
              'crop': {
                "height": item.height,
                "offsetLeft": 0,
                "offsetTop": 0,
                "width": item.width,
              },
              "default": {
                "height": item.height,
                "left": item.left,
                "top": item.top,
                "width": item.width,
              },
              "fixedLeft": 1008,
              "fixedTop": 210,
              "isFixedPos": false,
              "originHeight": item.width,
              "originWidth": item.height,
              'src': mycanvas[index+2].toDataURL("image/png"),
              "type": "3",
            }
          })
          if(sheetImgObj==undefined) {
            final[0].images=chartObj
          } else {
            const result=Object.assign(sheetImgObj,chartObj)
            final[0].images=result
          }
        }
        var timer=this.changeTimeFormat(this.specificTime)
        // console.log("final",final);

        // return
        exportExcel(final,sheet.name+timer);

        // exportSheetExcel(luckysheet.getluckysheetfile(), name);
      },

      //导入
      uploadExcel (evt) {
        const files=evt.target.files;
        // console.log("files",files);
        if(files==null||files.length==0) {
          alert("没有文件等待导入");
          return;
        }

        let name=files[0].name;

        let suffixArr=name.split("."),suffix=suffixArr[suffixArr.length-1];
        if(suffix!="xlsx") {
          this.$message({message: `当前仅支持导入xlsx文件`,type: 'warning'});
          return;
        }
        LuckyExcel.transformExcelToLucky(files[0],function(exportJson,luckysheetfile) {
          // console.log("exportJson",exportJson);
          if(exportJson.sheets==null||exportJson.sheets.length==0) {
            this.$message({message: `无法读取excel文件的内容，当前不支持xls文件！`,type: 'warning'});
            return;
          }
          window.luckysheet.destroy();

          window.luckysheet.create({
            container: 'luckysheet', //luckysheet is the container id
            showtoolbar: true,
            lang: "zh", //中文
            showinfobar: false,
            data: exportJson.sheets,
            title: exportJson.info.name,
            userInfo: exportJson.info.name.creator
          });
        });
      },
      //导入
      demoHandler (e) {
        console.log(1123);
        var vue=this;
        LuckyExcel.transformExcelToLucky(document.querySelector('#Luckyexcel-demo-file').files[0],
          (exportJson,luckysheetfile) => {
            if(exportJson.sheets==null||exportJson.sheets.length==0) {
              vue.$alert(
                "无法读取excel文件的内容，当前不支持xls文件！"
              );
              return;
            }
            console.log("exportJson.sheets",exportJson.sheets);
            window.luckysheet.destroy();
            vue.options.data=exportJson.sheets;
            window.luckysheet.create(vue.options);
          }
        );
      },
      //新增（查询）
      addExcel_fn () {
        this.dialogVisible=true
        // this.statementFindTreeFun()
        setTimeout(() => {
          this.operateTree_fn(0,1)
        },200)

      },
      //树形结构选中节点
      currentChecked (nodeObj,SelectedObj) {

        this.checkedNodes=SelectedObj.checkedNodes
        this.checkedNodes.forEach((item,index) => {
          if(!item.Content.hasOwnProperty('variableName')) {
            this.checkedNodes.splice(index,1)
          }
        })
        this.checkedNodes.forEach((item,index) => {
          if(item.hasOwnProperty('ChildDatas')) {
            this.checkedNodes.splice(index,1)
          }
        })
        this.halfCheckedNodes=SelectedObj.halfCheckedNodes
        this.halfCheckedNodes.splice(0,1)

      },

      //树形结构筛选
      filterNode (value,data) {
        if(!value) return true;
        return data.Content.Name.indexOf(value)!==-1;
      },
      //类型筛选
      screenType_fn (value) {
        var a=JSON.parse(JSON.stringify(this.treeListCopy))
        var recursiveFunction=function() {
          const getStr=function(list) {
            list.forEach(function(row) {
              if(row.Content.Category=="Device") {
                row.ChildDatas=row.ChildDatas.filter(v => v.Content.Id==value)
              } else {
                if(row.ChildDatas==null) {
                  row.ChildDatas=[]
                }
                getStr(row.ChildDatas)
              }
              
            })
          }
          getStr(a)
        }
        recursiveFunction()

        this.treeList=a


      },


      //选择企业
      enterpriseNodeClick (a) {

        this.enterpriseName=a.label
        this.enterpriseID=a.id
        this.treeList=[]
        this.shouMenu=false
        // this.handleData(res)
        statementVariableTree({"unitId": this.enterpriseID}).then(res => {
          if(res.code==200) {
            this.handleData(res)
          }

        })

      },
      //处理企业数据
      handleData (data) {
        data=JSON.parse(JSON.stringify(data).replace(/appTypes/g,'ChildDatas').replace(/groupName/g,"Name").replace(/groupIdAndName/g,"Content").replace(/groupId/g,"Id").replace(/appTypeInfo/g,"Content").replace(/appName/g,"Name"))

        var recursiveFunction=function() {
          const getStr=function(list) {
            list.forEach(function(row) {
              if(row.ChildDatas.length!=0) {

                getStr(row.ChildDatas)
              } else {
                row.ChildDatas=row.Content.groups
              }
            })
          }
          getStr([data.data])
        }
        recursiveFunction()



        // var abc = 	[a.data].filter(item => item.Content.groups.hasOwnProperty('groupIdAndName'))
        this.treeList=[data.data];
        this.treeListCopy=this.treeList


      },



      //测试
      bbb () {
        // var b = this.$store.state.tagsView.aaa;
        tagsView.mutations.modifyData()
        var b=tagsView.state.ccc;
        // console.log("表格数据",b);
        // b[0].name = "修改"
        window.luckysheet.destroy();
        this.options.data=b;
        window.luckysheet.create(this.options);
      },




    },
    filters: {
      valueTimeFil (val) {
        if(val=='MON') {
          return '月'
        } else if(val=='DAY') {
          return '日'
        }
      }
    }

  };
</script>

<style scoped lang="scss">
  /deep/.el-row {
    display: flex;
    align-items: center;
  }

  /deep/.title {
    margin-bottom: 0px !important;
    line-height: 1px !important;
  }

  .mypicker {
    width: 285px !important;

    /deep/.el-input__icon {
      line-height: 22px !important;
    }

    /deep/.el-range-separator {
      line-height: 22px !important;
    }
  }

  .mask {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2020;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .top-tree {
    width: 100%;
    height: 400px;
  }


  // 头部样式
  .choice {
    width: 100%;
    height: 130px;
    // margin-bottom: 25px;
    margin-top: 2px;
    display: flex;
    align-items: center;

    .choice-title {
      text-align: center;
      margin-bottom: 5px;
      border-bottom: 1px solid #ccc;
    }

    .choice-left {
      width: 200px;
      height: 100%;
      border: 1px solid #ccc;

      .tyep-radio {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 30px;

        /deep/.el-radio {
          margin-right: 10px;
        }
      }
    }

    .choice-middle {
      width: 660px;
      height: 100%;
      border: 1px solid #ccc;

      .value-type {
        margin-left: 20px;
      }

      .column-type {
        margin-left: 20px;
        margin-top: 4px;
        display: flex;
        align-items: center;

        .tebie {
          /deep/.el-input__inner {
            height: 25px;
          }
        }

      }
    }

    .choice-right {
      height: 100%;
      width: 305px;
      border: 1px solid #ccc;

      .specific-timer {
        margin-left: 10px;
        margin-top: 10px;

        /deep/.el-date-editor.el-input {
          width: 185px;
        }
      }

      .look {
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 10px;
      }

    }

    .choice-btns {
      flex: 1;
      height: 100%;
      border: 1px solid #ccc;

      // margin-top: 10px;
      // display: flex;
      // justify-content: space-evenly;
      // align-items: center;
      div {
        display: flex;
        justify-content: space-evenly;
        margin-bottom: 10px;
      }

      button {
        margin-bottom: 5px;
      }

      input {
        width: 65%;
      }
    }
  }

  .active {
    // background-color: #409eff;
    color: #fff;
  }

  /deep/.is-checked+.custom-tree-node {
    background-color: #fff !important;
    color: #606266 !important;
  }

  .home {
    padding: 10px;
    background: #eaecf0;
    position: relative;
    box-sizing: border-box;
  }

  /deep/.el-dialog {
    width: 22%;
  }

  .specific-timer {
    /deep/.el-input__icon {
      line-height: 30px;
    }
  }

  /deep/.el-select {
    width: 80px;
  }

  .value-type {
    /deep/.el-select {
      width: 200px;
    }
  }

  /deep/.el-radio {
    margin-right: 10px;
  }

  .dia-input {
    display: flex;
    justify-content: center;
    margin-top: 10px;

    input {
      width: 280px;
      margin-right: 10px;
    }
  }

  .btnss {
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;
  }

  .switch {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    margin-bottom: 20px;
    position: relative;

    img {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;

      &.img-active {
        transform: rotateY(-180deg);
      }
    }

    div {
      z-index: 100;
      width: 50%;
      height: 100%;
      text-align: center;
      line-height: 40px;
      cursor: pointer;

      &.active {
        // background-color: #409eff;
        color: #fff;
      }
    }
  }

  .select-enterprise {
    width: 90%;
    height: 30px;
    border: 1px solid #dcdfe6;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #c0c4cc;

  }

  .lefted {
    position: relative;
  }

  .el-icon-d-arrow-left {
    position: absolute;
    right: 0;
    top: 300px;
    z-index: 1;
    font-size: 28px;
    cursor: pointer;
    background: #d7d7d7;
    clip-path: polygon(-18px 35px,
        26px 100%,
        calc(100% - 1px) 100%,
        calc(100% - 0px) 0);
    height: 70px;
    line-height: 70px;
    color: #666;
  }

  /deep/.el-input__inner {
    height: 30px;
  }

  /deep/.el-select__caret {
    line-height: 25px;
  }


  .el-icon-d-arrow-right {
    position: absolute;
    left: 0;
    top: 300px;
    z-index: 1;
    font-size: 28px;
    cursor: pointer;
    background: #d7d7d7;
    clip-path: polygon(0 0,
        1px 100%,
        calc(100% - 26px) 100%,
        calc(100% - -27px) 31px);
    height: 70px;
    line-height: 70px;
    color: #666;
  }

  .screen-type {
    margin: 10px 0;

    display: flex;
    justify-content: center;

    /deep/.el-select {
      width: 90%;
    }

  }

  .unitMenu {
    width: calc(100% - 28px);
    height: 350px;
    // height: 100px;
    left: 13px;
    top: 50px;
    padding-top: .45rem;
    position: absolute;
    z-index: 99999;

    .unitMenuTreeBody {
      width: 100%;
      height: 100%;
      background: #fff;
      border: 1px solid #e6e6e6;
    }
  }

  .righted {
    box-sizing: border-box;
    position: relative;
    // min-height: calc(100% - 135px);
    height: 100%;
    background: #fff;
    border-left: 10px solid #eaecf0;
    padding: 10px;
  }

  // /deep/.el-tree-node:focus>.el-tree-node__content {
  //    background-color: #409eff;
  // }


  .demo-form-inline {
    position: relative;
    margin-top: 5px;
    z-index: 1;
  }

  .search {
    padding: 10px;
    display: block;
    padding-right: 25px;
    position: relative;
  }

  .is-checked+.custom-tree-node {
    background: #409eff;
    color: #fff;
  }

  .home {
    height: 100%;

    .lefted {
      height: 100%;
    }

    .equipment {
      height: calc(100% - 70px);
    }

    .record {
      width: 100%;
      height: calc(100% - 60px);
    }
  }

  .home .el-tree {
    // overflow-y: scroll;
    // left: 0;
    // bottom: 0;
    // height: 100%;
    // min-height: 400px;
    // width: 100%;
  }



  .websvg_box {
    display: block;
    overflow: scroll;
    width: 100%;
  }



  .wrapper {
    width: 100%;
    height: 500px;
  }

  .pagination_box {
    display: flex;
    justify-content: flex-end;
    margin-top: 5px;
  }

  /deep/.el-row {
    height: 100%;
  }
</style>